import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import Helmet from 'react-helmet'
import cx from 'classnames'
import intercomUpdate from 'decorators/intercomUpdate'
import keydown from 'react-keydown'
import links from 'misc/links'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'
import SlideTransition from 'components/SlideTransition'
import WizardHeader from './WizardHeader'
import WizardFooter from './WizardFooter'

import './styles.sass'

@intercomUpdate({ screen: 'Project Wizard' })
@observer
export default class ProjectWizard extends React.Component {
  static contextTypes = {
    router: PropTypes.any
  }

  @keydown('esc') onEscape () {
    this.context.router.push(links.projects())
  }

  componentWillMount () {
    this.props.rootStore.projectWizardStore.activate(this.props.params.id)
  }

  render () {
    const { rootStore } = this.props
    const wizard = rootStore.projectWizardStore
    const step = wizard.currentStep
    const StepComponent = require(`./Steps/${step.stepId}/index.jsx`).default
    const helmet = <Helmet title={(wizard.job && wizard.job.name) || 'New Project'} />
    return wizard.activate.match({
      pending: () => (
        <div>
          {helmet}
          <ContentLoading />
        </div>
      ),
      rejected: (err) => (
        <div>
          {helmet}
          <ContentError error={err} large />
        </div>
      ),
      resolved: () => (
        <div className="project-wizard animated is-faster fadeIn">
          {helmet}
          <WizardHeader wizard={wizard} />
          <SlideTransition
            transitionKey={step.stepId}
            invert={wizard.stepDelta === -1}
            wrapper={WizardContent}
          >
            <StepComponent step={step} />
          </SlideTransition>
          {step.nextEnabled !== undefined &&
            <WizardFooter wizard={wizard} />
          }
        </div>
      )
    })
  }
}

const WizardContent = ({className, ...props}) => (
  <div className={cx('wizard-content', className)} {...props} />
)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/index.jsx